import LabelInput from "../../../../../shared/components/labelInput";
import { useForm } from "react-hook-form";
import NewDateTimePicker from "../../../../../shared/components/newDateTimePicker";
import RadioGroup from "../../../../../shared/components/RadioGroup";
import SpCancellationMapper from "../mappers/spCancellationMapper";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import SupportNavigationButtons from "../../../components/support/SupportNavigationButtons";
import { handleSupportNext } from "../../../utils/supportNavUtils";
import { useNavigate } from "react-router-dom";
import FieldStack from "../../../../../shared/components/FieldStack";
import QuoteStepHeading from "../../../../../shared/components/QuoteStepHeading";

const SpCancellation = () => {
  const {
    register,
    watch,
    setValue,
    control,
    trigger,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    defaultValues: SpCancellationMapper.get(),
    mode: "onChange",
  });

  const reasonOptions = [
    {
      value: "cancellation_quote",
      label: "Cancellation Quote",
    },
    {
      value: "sold_vehicle_not_replacing",
      label: "Sold Vehicle - Not replacing",
    },
    { value: "sold_vehicle_replacing", label: "Sold Vehicle - Replacing" },
    { value: "going_abroad", label: "Going Abroad" },
    { value: "cant_afford", label: "Cant afford it" },
    {
      value: "not_happy_charges",
      label: "Doesn't want to pay AP/Not happy with charges",
    },
    { value: "health_reasons", label: "Health reasons" },
    { value: "lost_badge", label: "Lost Badge" },
    { value: "lost_driving_license", label: "Lost Driving license" },
    { value: "cheaper_price", label: "Found cheaper price" },
    { value: "stopping_driving", label: "Stopping driving/Retiring" },
    { value: "other", label: "Other" },
  ];
  const navigate = useNavigate();

  const onSubmit = (data) => {
    SpCancellationMapper.set(data);
    handleSupportNext(navigate);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <QuoteStepHeading title="Cancel policy" className="tw-mb-6" />
        <FieldStack className="tw-w-full">
        <NewDateTimePicker
          name="cancellationEffectiveDateTime"
          label="Effective Date and Time"
          errors={errors.cancellationEffectiveDateTime}
          setValue={setValue}
          control={control}
          rules={{ required: "Date is required" }}
          watch={watch}
          defaultValue={watch("cancellationEffectiveDateTime")}
          minDate={new Date()}
          trigger={trigger}
        />

        <LabelInput
          id="cancellationReason"
          label="Reason for Cancellation"
          type="select"
          options={reasonOptions}
          control={control}
          errors={errors.cancellationReason}
          placeholder="Select Reason"
          register={register("cancellationReason", {
            required: "Required",
          })}
          watch={watch("cancellationReason")}
          trigger={trigger}
        />
        {watch("cancellationReason")?.value === "other" && (
          <LabelInput
            id="otherReason"
            label="Please specify"
            type="textarea"
            placeholder="Enter details"
            register={register("otherReason", {
              required: "Comments are required",
            })}
            errors={errors.otherReason}
            watch={watch("otherReason")}
            trigger={trigger}
            maxLength={500}
          />
        )}
        <RadioGroup
          name="involved"
          mainLabel="Have you been involved in any accidents/claims since the policy started?"
          register={register}
          trigger={trigger}
          errors={errors.involved}
        />
        {watch("involved") === "Yes" && (
          <>
            <NewDateTimePicker
              name="accidentDate"
              label="Date of accident"
              errors={errors.accidentDate}
              setValue={setValue}
              trigger={trigger}
              control={control}
              rules={{ required: "Date is required" }}
              watch={watch}
              defaultValue={watch("accidentDate")}
              maxDate={new Date()}
            />
            <RadioGroup
              name="reported"
              mainLabel="Have you reported this to us?"
              register={register}
              trigger={trigger}
              errors={errors.reported}
            />
          </>
        )}
        </FieldStack>
        <p className="tw-mb-0 tw-mt-4 tw-text-dis-small tw-leading-[1.5] tw-text-dis-text-muted">
          Cancellation charges may apply. Your policy documents explain them.
        </p>
      </QuoteFormWrapper>
      <SupportNavigationButtons isValid={isValid} />
    </form>
  );
};

export default SpCancellation;
